import { render, staticRenderFns } from "./widget-event-register.vue?vue&type=template&id=73c37f46&scoped=true"
import script from "./widget-event-register.vue?vue&type=script&lang=ts"
export * from "./widget-event-register.vue?vue&type=script&lang=ts"
import style0 from "./widget-event-register.vue?vue&type=style&index=0&id=73c37f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c37f46",
  null
  
)

export default component.exports